import messages from './ChangerPassword.json'
import swal from 'sweetalert2'

export default {
  name: "ChangerPassword",
  i18n: messages,

  component: swal,

  data() {
    return {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''       
    }
  },
  methods: {
    /**
     * Fonction de changement de mot de passe
     **/

    updatePassword() {
      this.$validator.validateAll().then(isValid => {

        // Si la validation echoue : on arrete.
        if (!isValid) {
          return;
        }
        // Construction du DTO pour passage en param au back 
        let requestDTO = {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword
        }

        // Appel au WS de modif des info utilisateur
        this.$eventHub.$emit(this.$eventHub.LOADING.START)
        this.$axios.put('/rest/bd/utilisateur/updatePassword', requestDTO).then(
          response => {
            this.success(response)
            this.$eventHub.$emit(this.$eventHub.LOADING.END)
          }, error => {
            this.error(error.response)
            this.$eventHub.$emit(this.$eventHub.LOADING.END)
          }
        )
      })
    },

    /**
     * appelé lorsque la mise a jour des données s'est bien passée
     */
    success(response) {
      if (this.$val.isDefined(response.data.id)) {
        // On notifie l'erreur a l'utilisateur
        this.$notify.success({
          title: this.$t('notifications.success.title')
        })
      }
    },

    /**
     * appelé lorsque la mise a jour des données s'est mal passée
     */
    error(error) {
        console.log(error)
      //on notifie l'erreur a l'utilisateur
      this.$notify.error({
        title: this.$t('notifications.error.title'),
        message: this.$t('notifications.error.message')
      })
    },

  }
}
